import * as React from 'react';
import { useFeatureFlag } from '../../../shared/featureFlags/useFeatureFlag';
import { FeatureFlagKeys } from '../../../shared/featureFlags/featureFlagKeys';
import UnbookedOrdersPageV2 from '../listunbookedordersV2/UnbookedOrdersPageV2';
import UnBookedOrdersPage from './UnBookedOrdersPage';

function UnBookedOrdersPageDelegate() {
    let hasBookingsCalendarPageEnabled = useFeatureFlag(FeatureFlagKeys.ShowBookingsCalendarPage, false);

    if (hasBookingsCalendarPageEnabled) {
        return <UnbookedOrdersPageV2 />;
    }

    return <UnBookedOrdersPage />;
}

export default UnBookedOrdersPageDelegate;
